export const WORK_TYPES = {
  ARTICLE: "ARTICLE",
  SEARCH: "SEARCH",
  DISSERTATION: "DISSERTATION",
  EXTENSION: "EXTENSION",
  FINAL_THESIS: "FINAL_THESIS",
};
